<template>
    <div class="h-100">
        <div class="loader-cont" v-dxloader="isLoader"></div>   
        <div class="row h-100" v-show="!isLoader">
            <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
            <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
                <!-- Search for small screen-->
                <div class="container">
                    <div class="row">
                        <div class="col s10 m6 l6 alignLeft">
                            <h5 class="card-title alignLeft white-text">Pay In</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col s12 p-0" style="height:calc(100% - 45px)">
                <div class="container p-0 h-100">
                    <div class="section p-0 h-100">
                        <div class="row m-0 h-100">
                            <div class="col s12 m12 l12 p-0 h-100">
                                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                                    <div class="card-content h-100" style="overflow:auto">
                                        <div class="row">
                                            <div class="col s6 search-input">
                                                <div class="sidebar-search animate fadeUp">
                                                    <div class="search-area">
                                                        <i class="material-icons mr-2 search-icon">search</i>
                                                        <i class="material-icons mr-2 close-icon" v-show="searchText"  @click="searchText=''">close</i>
                                                        <input
                                                        type="text"
                                                        v-model="searchText"
                                                        placeholder="Search by bookingid, txn id"
                                                        class="app-filter"
                                                        id="chat_filter"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row payinblock" style="height: calc(100% - 84px);">
                                            <div class="col s12">
                                                <table class="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            <th data-field="index">Booking ID</th>
                                                            <th data-field="index">Transaction ID</th>
                                                            <th data-field="name">Email Address</th>
                                                            <th data-field="id">Contact Number</th>
                                                            <th data-field="price">Amount</th>
                                                            <th data-field="status">Status</th>
                                                            <th data-field="date">Created At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="item in payInsList.results" :key="item.id">
                                                            <td>{{item.booking}}</td>
                                                            <td>{{item.razorpay_order_id}}</td>
                                                            <td>{{item.email}}</td>
                                                            <td>{{item.contact_number}}</td>
                                                            <td>Rs.{{item.amount_in_rupees || 0}}</td>
                                                            <td class="caps">{{item.status}}</td>
                                                            <td>{{item.created_at | date('DD MMM YY, hh:mm a')}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                isLoader : true,
                payInsList : {
                    results : [],
                    count : 0,
                    previous : null,
                    next : null
                },
                searchText : ""
            }
        },
        created(){
            this.listPayIns();
             var thisObj = this;
            setTimeout(() => {
                Vue.scrollBottom($('.card-content'), () => {
                    if (thisObj.payInsList.next) {
                        thisObj.listPayIns(thisObj.payInsList.next, true);
                    }
                })
            }, 500);
        },
        methods : {
            listPayIns(url = Constants.default.APIURL.PayIns,status=false) {
                return new Promise(resolve => {
                    ajax.get(
                    url,
                    res => {
                        this.isLoader = false;
                        if (status) {
                            let temp = this.payInsList.results;
                            this.payInsList = {
                                count: res.data.count,
                                previous: res.data.previous,
                                next: res.data.next
                            };
                            this.payInsList.results = temp.concat(res.data.results);
                        } else {
                            this.payInsList = res.data;
                        }
                        if(this.payInsList.results.length==0){
                            Vue.showNoDataBlock('.payinblock');
                        }else{
                            Vue.hideNoDataBlock('.payinblock');
                        }

                    },err =>{
                        this.isLoader = false;
                    });
                });
            }
        },
        watch: {
            searchText(text){
                let url = Constants.default.APIURL.PayIns + text;
                this.listPayIns(url);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .caps{
        text-transform: capitalize;
    }
    .search-input {
        .sidebar-search {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        // padding: 1rem 0;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -moz-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        }
        .search-area {
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            width: -webkit-calc(100% - 0rem);
            width: -moz-calc(100% - 0rem);
            width: calc(100% - 0rem);
            -webkit-box-align: center;
            -webkit-align-items: center;
            -moz-box-align: center;
            -ms-flex-align: center;
            align-items: center;
        }
        i {
            font-size: 1.45rem;
            height: 41px;
            margin-right: 0 !important;
            padding: 0.75rem 0.25rem 0.35rem 0.75rem;
            color: #9e9e9e;
            border-radius: 5px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            background-color: #eceff1;
        }
        .app-filter {
            height: 35px;
            margin-bottom: 0;
            padding: 0.2rem;
            color: #9e9e9e;
            border: none;
            border-radius: 5px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background-color: #eceff1;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            border-bottom: 0 !important;
            box-shadow: none !important;
        }
    }
    .search-area{
        i.close-icon{
            position: absolute;
            right: 10px;
            cursor: pointer;
            font-size: 18px;
            top: 22px;
            height: inherit;
            padding: 0;
            line-height: 0;
        }
    }
</style>

